import { Drawer as DrawerMUI } from '@mui/material';
import { type ConnectedProps, connect } from 'react-redux';
import { type RootState } from '@/store';
import { isDrawerOpen, drawerType, drawerData, closeDrawer } from '../state';
import { getDrawerContent } from './getDrawerContent';
import styles from './styles';

type Props = ConnectedProps<typeof connector>;

const Drawer = ({
  isDrawerOpen,
  drawerType,
  drawerData,
  closeDrawer,
}: Props) => {
  const DrawerContent = getDrawerContent(drawerType);

  const handleClose = () => {
    closeDrawer();
  };

  return (
    <DrawerMUI
      anchor="right"
      open={isDrawerOpen}
      onClose={handleClose}
      sx={styles.root}
      ModalProps={{
        disableEnforceFocus: true,
        disableAutoFocus: true,
      }}
    >
      <DrawerContent closeDrawer={handleClose} drawerData={drawerData} />
    </DrawerMUI>
  );
};

const connector = connect(
  (state: RootState) => ({
    isDrawerOpen: isDrawerOpen(state),
    drawerType: drawerType(state),
    drawerData: drawerData(state),
  }),
  { closeDrawer },
);

export default connector(Drawer);
